var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExplore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.93962 5.18504C5.62258 5.18504 5.36791 5.43972 5.36791 5.75676C5.36791 6.07381 5.62258 6.32848 5.93962 6.32848C6.25667 6.32848 6.51134 6.07381 6.51134 5.75676C6.51134 5.43972 6.25667 5.18504 5.93962 5.18504ZM5.93962 0.559326C3.07064 0.559326 0.742188 2.88778 0.742188 5.75676C0.742188 8.62575 3.07064 10.9542 5.93962 10.9542C8.80861 10.9542 11.1371 8.62575 11.1371 5.75676C11.1371 2.88778 8.80861 0.559326 5.93962 0.559326ZM7.07786 6.895L2.82116 8.87522L4.80138 4.61852L9.05808 2.6383L7.07786 6.895Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/explore.dc8d6518db18991f42d820111c376070.svg";
export { ForwardRef as ReactComponent };